import type { VenueClientModule } from "../types";
import { truckDriving } from "./driver";
import { TrucksCompact, TrucksHud } from "./Hud";
import { buildTruckArena3d } from "./scene";

/**
 * Monster Truck Arena on the client (ADR-0016, ADR-0032): the arena and its trucks, the overlay (with the race banner
 * and finish screen, kept on screen when the panel is collapsed), and the driving hooks.
 */
export const truckArenaClient: VenueClientModule = {
  kind: "truck_arena",
  build3d: buildTruckArena3d,
  Hud: TrucksHud,
  Compact: TrucksCompact,
  driving: truckDriving,
};
